var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg73Undelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#474749;}.cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:.75px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 8,
    ry: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.74,5.62h3.95c.55,0,1,.45,1,1v.51H5.74v-.51c0-.55,.45-1,1-1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.69,
    y: 4,
    width: 2.05,
    height: 0.81,
    rx: 0.4,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.1,7.94v3.58c0,.26,.24,.48,.53,.48h4.19c.29,0,.53-.21,.53-.48v-3.58H6.1Zm2.91,3.17c0,.16-.13,.28-.28,.28s-.28-.13-.28-.28v-2.27c0-.16,.13-.28,.28-.28s.28,.13,.28,.28v2.27Zm1.62,0c0,.16-.13,.28-.28,.28s-.28-.13-.28-.28v-2.27c0-.16,.13-.28,.28-.28s.28,.13,.28,.28v2.27Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.36,
    y: 8.87,
    width: 3.41,
    height: 2.17,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.42,11.46c.08-.07,.11-.15,.11-.24,0-.08-.03-.16-.1-.23l-1.07-1.04,1.07-1.04c.14-.13,.13-.34-.01-.47-.15-.13-.38-.12-.51,.01l-1.31,1.27c-.13,.13-.13,.33,0,.46l1.31,1.27c.14,.13,.37,.14,.51,.01Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4.36,
    y1: 9.95,
    x2: 6.7,
    y2: 9.95
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg73Undelete);
export default __webpack_public_path__ + "static/media/73-undelete.dddc57d4855a80b0a2796d6da043fa57.svg";
export { ForwardRef as ReactComponent };